import {Component, inject, OnInit, signal} from '@angular/core';
import {DataService} from '../../services/data';
import {Router} from '@angular/router';
import {AccessService} from '../../services/access';
import {DatePipe} from '@angular/common';
import {LocalStorageService} from '../../services/local-storage';
import {FormsModule} from '@angular/forms';
import {Header} from '../header/header';

@Component({
    selector: 'app-start',
    imports: [
        DatePipe,
        FormsModule,
        Header
    ],
    templateUrl: './start.html',
    styleUrl: './start.css',
})
export class Start implements OnInit {

    private dataService = inject(DataService);
    private accessService = inject(AccessService);
    private router = inject(Router);
    private localStorageService = inject(LocalStorageService);

    tokenValid = signal(false);
    roomValid = signal(false);

    private roomHash = signal('');
    room = signal<any>({});

    name = '';

    ngOnInit() {
        const token = this.router.url.split('/')[2];
        this.roomHash.set(this.router.url.split('/')[3]);

        this.dataService.request('Client/checkToken', {
            token,
            domain: this.accessService.client.domain
        }).subscribe((response) => {
            this.tokenValid.set(response.tokenValid);

            if (response.tokenValid) {
                this.accessService.token = token;

                this.dataService.request('Room/get', {
                    hash: this.roomHash()
                }).subscribe((response) => {
                    if (response.room) {
                        this.roomValid.set(true);
                        this.room.set(response.room);

                        this.name = this.localStorageService.getItem('creator') ?? '';
                    }
                })
            }
        });
    }

    join() {
        const url = "https://" + this.accessService.client.vhost + "/VRoom-" + this.room().id + "-" + this.room().topic + '#userInfo.displayName="' + this.name + '"';
        window.location.href = url;
        //window.open(url, '_blank');
    }

}
